module.exports = __webpack_public_path__ + "static/img/3-3.a3f8205.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3-3.jpg
// module id = Hbwz
// module chunks = 0